import { Checkbox, FormGroup, FormGroupFeedback, IFormGroupProps, Intent } from '@pinpointhq/thumbtack';
import { FieldHelperProps, FieldInputProps, FieldMetaProps, useField, useFormikContext } from 'formik';
import * as React from 'react';

interface ICheckboxGroupFieldProps {
  inline?: boolean;
  options: { name: string; label: string; disabled?: boolean }[];
  submitOnChange?: boolean;
  formGroupProps?: Omit<IFormGroupProps, 'labelFor'>;
}

export default function CheckboxGroupField<T extends boolean>({
  formGroupProps,
  inline,
  options,
  submitOnChange,
}: ICheckboxGroupFieldProps) {
  const { submitForm } = useFormikContext();

  const checkboxes = options.map((option) => {
    const { label, disabled, name } = option;
    const [field, meta, helpers]: [FieldInputProps<T>, FieldMetaProps<T>, FieldHelperProps<T>] = useField<T>(name);
    const hasError = meta.touched && meta.error;

    const onCheckboxChange = (event: React.FormEvent<HTMLInputElement>) => {
      helpers.setValue(event.currentTarget.checked as T);
      if (submitOnChange) submitForm();
    };

    return (
      <React.Fragment key={option.label}>
        <Checkbox onChange={onCheckboxChange} {...{ inline, label, disabled }} checked={field.value} />
        {hasError && <FormGroupFeedback intent={Intent.DANGER}>{meta.error}</FormGroupFeedback>}
      </React.Fragment>
    );
  });

  return <FormGroup {...formGroupProps}>{checkboxes}</FormGroup>;
}
